import styled from 'styled-components';

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #0e1318;
  font-weight: ${props => (props.active ? 'bold' : '')};
  justify-content: ${props => (props.variable && 'space-between')};
  .anticon {
    margin: 0px 0px 0px 15px;
    color: green;
  }
  .menu-helptxt {
    font-size: 12px;
    color: rgba(30, 41, 51, 0.45);
    margin: 0px 8px;
  }
`;
